export function RemoverMascara(value) {
    if (!value) return "";

    return value.replace(/\D/g, "");
}